// extracted by mini-css-extract-plugin
module.exports = {"list":"FaqPage_list__2L-WI","entry":"FaqPage_entry__1MW39","title":"FaqPage_title__3Mzy_"};